import { useState } from "react";
import { api, ApiError } from "../lib/api";
import { PriorityBadge, StatusBadge } from "../components/StatusBadges";

interface LookupResult {
  incident_number: string;
  status: string;
  priority: string;
  created_at: string;
  updated_at: string;
  description: string;
}

export function StatusCheck() {
  const [number, setNumber] = useState("");
  const [email, setEmail] = useState("");
  const [result, setResult] = useState<LookupResult | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setResult(null);
    try {
      const data = await api.get<LookupResult>(
        `/incidents/lookup?number=${encodeURIComponent(number.trim())}&email=${encodeURIComponent(email.trim())}`
      );
      setResult(data);
    } catch (e) {
      setError(e instanceof ApiError ? e.message : "We couldn't find that incident.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="container">
      <div className="card">
        <h2>Check My Incident</h2>
        <p className="hint">Enter your incident number and the email address you submitted it with.</p>
        <form onSubmit={onSubmit}>
          <div className="field">
            <label htmlFor="number">Incident number</label>
            <input id="number" type="text" placeholder="TECH-2026-0001" value={number} onChange={(e) => setNumber(e.target.value)} required />
          </div>
          <div className="field">
            <label htmlFor="email">Email address</label>
            <input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
          {error && (
            <div className="alert-banner" role="alert">
              {error}
            </div>
          )}
          <button className="btn btn-primary" type="submit" disabled={loading}>
            {loading ? "Searching…" : "Check Status"}
          </button>
        </form>

        {result && (
          <div className="info-banner" style={{ marginTop: "1.5rem" }}>
            <h3>{result.incident_number}</h3>
            <p>
              <StatusBadge status={result.status} /> <PriorityBadge priority={result.priority} />
            </p>
            <p>{result.description}</p>
            <p className="hint">
              Submitted {new Date(result.created_at).toLocaleString()} · Last updated{" "}
              {new Date(result.updated_at).toLocaleString()}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
